import PSelect from './inputs/select/PSelect'
import Amount from './inputs/amount/Amount'
import Period from './inputs/period/Period'
import Interval from './inputs/interval/Interval'

function Form ({ values, setters, purposes, purposeData }) {

  return (
    <>
      <PSelect className="mb-40"
               label="Purpose of Loan"
               purpose={values.purpose}
               purposes={purposes}
               handler={setters.setPurpose}
      />
      <Amount className="mb-30"
              label="Amount"
              purposeData={purposeData}
              handler={setters.setAmount}
              amount={values.amount} />
      <Period className="mb-30"
              label="Period of time"
              purposeData={purposeData}
              handler={setters.setPeriod}
              period={values.period} />
      <Interval interval={values.interval}
                handler={setters.setInterv} />
    </>
  )
}

export default Form
